import { Dayjs } from "dayjs";
import {
  ExpressDocType,
  ExpressDocumentListParams,
  ExpressDocumentStatus,
} from "../../types/express-document.type";
import { formatDateParam } from "../ETax/dateRangeParams";
import { ALL } from "../CreditDebitNote/constants";
import { DOCUMENT_STATUS_LABEL } from "./constants";

export interface DocumentListFilterValue {
  /** ALL, or the branch_code head office picked. */
  branchCode: string;
  dateFrom: Dayjs | null;
  dateTo: Dayjs | null;
  status: ExpressDocumentStatus | typeof ALL;
  search: string;
}

export type DocumentFilterParams = Omit<ExpressDocumentListParams, "page" | "limit">;

export const EMPTY_DOCUMENT_LIST_FILTER: DocumentListFilterValue = {
  branchCode: ALL,
  dateFrom: null,
  dateTo: null,
  status: ALL,
  search: "",
};

export const DOCUMENT_STATUS_FILTER: { value: ExpressDocumentStatus | typeof ALL; label: string }[] = [
  { value: ALL, label: "ทั้งหมด" },
  { value: "ACTIVE", label: DOCUMENT_STATUS_LABEL.ACTIVE },
  { value: "CANCELLED", label: DOCUMENT_STATUS_LABEL.CANCELLED },
];

/** A picked filter value, or nothing for ทั้งหมด. */
const pickedValue = <Value extends string>(value: Value | typeof ALL): Value | undefined =>
  value === ALL ? undefined : value;

/** The list's query for one type: ทั้งหมด, blank text and unfinished dates are left out. */
export const documentFilterParams = (
  docType: ExpressDocType,
  filter: DocumentListFilterValue,
): DocumentFilterParams => ({
  doc_type: docType,
  date_from: formatDateParam(filter.dateFrom) ?? undefined,
  date_to: formatDateParam(filter.dateTo) ?? undefined,
  status: pickedValue(filter.status),
  search: filter.search.trim() || undefined,
  branch_code: pickedValue(filter.branchCode),
});
